<template>
    <div class="header bg-green py-6">
    <div class="container-fluid">
    <div class="row text-center">
      <div class="container">
        <div class="row position-relative">

         <a class="btn w-auto offcanvas-btn" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button" aria-controls="offcanvasExample">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" class="bi bi-list" viewBox="0 0 16 16">
        <path fill-rule="evenodd"
          d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
      </svg>
    </a>

       <router-link :to="{name: 'Home'}" class="gb-title text-white"><img class="logo" alt="GreenBook Logo" src="@/assets/greenbook-logo.png"></router-link>
   

     </div>
     </div>
     </div>
      </div>

       <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
    <div class="offcanvas-header d-flex flex-row align-items-end justify-content-end">
      <button type="button" class="btn-close text-reset float-righ" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body d-flex flex-column align-items-center">
      <router-link :to="{name: 'Home'}">Search Again</router-link>
      <router-link :to="{name: 'About'}">About</router-link>
      <router-link :to="{name: 'Information'}">Supplementary Information</router-link>
     <a href="http://www.wanada.org.au/" >VISIT THE WANADA HUB</a>
      <img class="logo mb-3" alt="GreenBook Logo" :src="baseURL  + '/green-book-dark.png'">
        <div class="address-footer mb-4">
   <p class="mb-0">General Enquiries</p>
   <p class="mb-0">Email: <a class="" href="mailto:drugpeak@wanada.org.au">drugpeak@wanada.org.au</a></p>
   <p class="mb-0">Phone: <a class="" href="tel:(08) 6557 9400">(08) 6557 9400</a></p>
   </div> 
<div class="address-footer mb-4">
   <p class="mb-0">WANADA</p>
   <p class="mb-0">Whadjuk Noongar Country</p>
   <p class="mb-0">Level 1, 1 Nash St</p>
   <p class="mb-0">Perth, WA 6000</p>
   </div>
 
   
   <p class="mb-5 d-none">© WANADA MadebyLoaded</p>
   <a href="http://www.wanada.org.au/" target="_blank"><img class="wanada-footer mb-3" alt="WANADA Logo" :src="baseURL  + 'wanada-logo-dark.png'"><span class="screen-reader-only">(opens in a new tab)</span></a>
      
    </div>
  </div>
  </div>

   

</template>

<script>
export default {
  data() {
    return{
       baseURL:'https://wanada.org.au/wp-content/themes/wanada-child/img/',
    }
  }

}
</script>

<style lang="scss">
// @import '@/assets/app.scss';
</style>
